
export const generateThumbnails = async (
    videoBlob: Blob,
    duration: number,
    count: number = 20
): Promise<string[]> => {
    return new Promise((resolve) => {
        const videoUrl = URL.createObjectURL(videoBlob)
        const video = document.createElement('video')
        video.crossOrigin = 'anonymous'
        video.muted = true
        video.playsInline = true
        video.preload = 'metadata'

        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')
        const thumbnails: string[] = []

        let isResolved = false
        const done = (thumbs: string[]) => {
            if (isResolved) return
            isResolved = true
            URL.revokeObjectURL(videoUrl)
            resolve(thumbs)
        }

        // Hard timeout — never hang forever
        const timeout = setTimeout(() => done(thumbnails), 30_000)

        video.onloadedmetadata = () => {
            const vw = video.videoWidth || 1920
            const vh = video.videoHeight || 1080
            canvas.width = 160
            canvas.height = Math.round((vh / vw) * 160)

            const interval = duration / count
            let currentTime = 0
            let captured = 0

            const captureFrame = () => {
                if (captured >= count) {
                    clearTimeout(timeout)
                    done(thumbnails)
                    return
                }
                video.currentTime = Math.min(currentTime, duration - 0.01)
            }

            video.onseeked = () => {
                if (!ctx || isResolved) return
                // Small delay to ensure frame is decoded
                setTimeout(() => {
                    try {
                        ctx.drawImage(video, 0, 0, canvas.width, canvas.height)
                        thumbnails.push(canvas.toDataURL('image/jpeg', 0.5))
                    } catch {
                        // Frame not ready — push a blank placeholder so count stays consistent
                        thumbnails.push('')
                    }
                    captured++
                    currentTime += interval
                    captureFrame()
                }, 50)
            }

            // Start capturing
            captureFrame()
        }

        video.onerror = () => {
            clearTimeout(timeout)
            done([])
        }

        // Setting src AFTER attaching listeners, then calling load()
        // is the reliable cross-browser pattern.
        video.src = videoUrl
        video.load()
    })
}
